import type { PortfolioData } from '../../firebase/types/portfolio.types';
import { Band, SectionIndex } from './ui';

export default function SkillsSection({ data, index }: { data: PortfolioData; index: string }) {
  const categories = data.skillCategories ?? [];
  const skills = data.skills ?? [];
  const useCategories = categories.length > 0;

  return (
    <Band id="skills">
      <SectionIndex index={index} title="Skills" />
      {useCategories ? (
        <div className="grid gap-3 md:grid-cols-2">
          {categories.map((category, i) => (
            <article key={`${category.category}-${i}`} className="panel p-4 md:p-5">
              <h3 className="text-base font-semibold">{category.category}</h3>
              <ul className="mt-3 flex flex-wrap gap-1.5">
                {(category.skills ?? []).map((skill, j) => (
                  <li key={`${skill}-${j}`} className="chip">{skill}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      ) : (
        <ul className="grid gap-3 sm:grid-cols-2">
          {skills.map((skill, i) => {
            const amount = skill.percentage;
            const width = amount == null ? 0 : Math.max(0, Math.min(100, amount));
            return (
              <li key={`${skill.name}-${i}`} className="panel px-4 py-3">
                <div className="flex items-baseline justify-between gap-4">
                  <span className="text-sm text-ink">{skill.name}</span>
                  {amount != null ? <span className="text-sm text-signal">{amount}%</span> : null}
                </div>
                {amount != null ? (
                  <div className="mt-2 h-px bg-line" aria-hidden="true">
                    <div className="h-px bg-accent" style={{ width: `${width}%` }} />
                  </div>
                ) : null}
              </li>
            );
          })}
        </ul>
      )}
    </Band>
  );
}
